import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {Icon} from 'react-fa'
import InputText from './input'
import InputNumber from './inputNumber'
import Checkbox from './checkbox'

import check from '../images/check.svg'

import { sendForm, resetForm } from '../actions/formulaire'
import { isEmail, isTelephoneNumber } from '../actions/helpers'

class Formulaire extends Component {

  constructor(props){
    super(props)
    this.state = {
      errors : {},
      sent : false,
      hide : false
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.message === "sent"){
      this.props.resetForm()
      this.setState({ sent : true})
      setTimeout(()=>{this.setState({hide:true})},3000);
      setTimeout(()=>{this.setState({sent:false})},3600);
      setTimeout(()=>{this.setState({hide:false})},4000);
    }
  }

  sendForm(){
    var errors = {}
    var bool = true;

    if(!this.props.form.seance || this.props.form.seance == ""){
      errors.seance = "Veuillez indiquer la séance à laquelle vous souhaitez participer."
      bool = false;
    }

    if(!this.props.form.entreprise || this.props.form.entreprise == ""){
      errors.entreprise = "Veuillez indiquer le nom de l'entreprise pour laquelle vous travaillez."
      bool = false;
    }
    if(!this.props.form.name || this.props.form.name == ""){
      errors.name = "Veuillez indiquer votre nom et prénom."
      bool = false;
    }
    if(!isEmail(this.props.form.email)){
      errors.email = "Veuillez indiquer votre adresse email."
      bool = false;
    }
    if(!isTelephoneNumber(this.props.form.phone)){
      errors.phone = "Veuillez indiquer un numéro de téléphone où vous joindre."
      bool = false;
    }

    this.setState({errors})

    if(bool){
      console.log("send email");
      this.props.sendForm(this.props.form);
    }
  }

  render() {
    const errors = this.state.errors
    var sent = "";
    var hide = "";
    if(this.state.sent){
      sent = "sent"
    }
    if(this.state.hide){
      hide = "hide"
    }
    return (
      <div id="form" className="formulaire">
        <div className="container">
          <h3>Réservez un agréable moment en notre compagnie*</h3>
          <p className="warn">*Offre réservée aux agences et entreprises</p>
          <div className="container">
            <div className="containerCheckbox">
              <div>
                <Checkbox id="ux" label={"U QUOI ?"}/>
                <Checkbox id="dataviz" label={"DATA DOUDOU DIS DONC !"}/>
                <Checkbox id="sceno" label={"POMPOM PÉ DUP !"}/>
              </div>
              {(errors.seance) ? (<p className="warn center">{errors.seance}</p>) : null}
            </div>
            <InputText error={errors.entreprise} index={"entreprise"} label="Entreprise" />
            <InputText error={errors.name} index={"name"} label="Nom / Prénom" />
            <InputNumber />
            <InputText error={errors.email} index={"email"} label="Adresse Email" />
            <InputText error={errors.phone} type="phone" index={"phone"} label="Numéro de téléphone" />

            <button className={sent+" "+hide} onClick={this.sendForm.bind(this)}>
              <span className="text">Réserver ma séance</span>
              <div className="check">
                <img src={check} alt="check" />
              </div>
              <div className="circle">
                <svg height="67" width="66">
                  <circle cx="30" cy="30" r="28" stroke="#E75535" strokeWidth="3" fill="none" />
                </svg>
              </div>
            </button>
            <p className='subtitle'>N'hésitez pas c'est gratuit !</p>
          </div>
        </div>
      </div>
    )
  }

}
// <Icon size="2x" name="check" />


function mapDispatchToProps(dispatch){
  return bindActionCreators({
    sendForm : sendForm,
    resetForm : resetForm
  },dispatch)
}

function mapStateToProps(state) {
  return {
    form : state.form,
    message : state.message
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Formulaire);



// WEBPACK FOOTER //
// ./src/client/components/formulaire.js